module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Frederick P. Hitz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Frederick P. Hitz, author of "), _c('I', [_vm._v("The Great Game: The Myths and Reality of Espionage,")]), _vm._v(" was inspector general of the CIA from 1990 to 1998. He also has been a lecturer at Princeton University. He currently teaches at the University of Virginia's School of Law and Department of Politics.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bPx9wf/tc-custom/9781429932950.jpg?1732052885647",
      "alt": "This image is the cover for the book Why Spy?"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Why Spy?\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("What motivates someone to risk his or her life in the shadowy, often dangerous world of espionage? What are the needs and opportunities for spying amid the \"war on terrorism\"? And how can the United States recruit spies to inform its struggle with Islamic fundamentalists' acts of anti-Western jihad?"), _c('br'), _c('br'), _vm._v("Drawing on over twenty-five years of experience, Frederick P. Hitz, a former inspector general of the Central Intelligence Agency, guides the reader through the byzantine structure of the U.S. intelligence community (which agency handles what?), traces the careers and pitfalls of such infamous spies as Robert Hanssen and Aldrich Ames, and explains how the United States must meet the challenges set forth in the Intelligence Reform and Terrorism Prevention Act of 2004. He also describes the transformation of the CIA after the end of the cold war--from 1991 to the present--and outlines a vision for the future of U.S. spying in the twenty-first century."), _c('br'), _c('br'), _vm._v("A fascinating glimpse into the inner workings of international espionage and intelligence, "), _c('i', [_vm._v("Why Spy?")]), _vm._v(" is a must-read not only for fans of Tom Clancy and John le Carré, but for anyone concerned about the security of the United States in a post-cold war, post-9/11 world.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0